import React from 'react';
import { getSearchResult } from '../actions/searchAction';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import Header from '../components/HeaderComponent';
import AddAudienceWhatsapp from '../components/AddAudienceWhatsapp';
import AudienceListWhatsapp from '../components/AudienceLisWhatsapp';
import BulkMessageList from '../components/BulkMessageList';
import SendMessageForm from '../components/SendMessageForm';
import { connect } from 'react-redux';
import "../styles/ProcurementPortalStyles.css";
import { Redirect } from 'react-router-dom';
import { addAudienceWhatsapp, fetchAudienceList, sendMessageWhatsapp, fetchBulkMessageList, approveMessage, testSendMessage, downloadAudFormat, downloadAudFile, downloadAttachmentFile, cancelMessage } from '../actions/sendWhatsappActions';


class SendMessage extends Component {

    constructor() {
        super();
        this.state = {
            selectedTab: "sendMessage",
            userObj: {}
        };
    }

    componentWillMount() {
        if (localStorage.getItem("userObj")) {
            let userObj = JSON.parse(localStorage.getItem("userObj"));
            this.setState({
                userObj
            })
        }
    }

    handleOnViewChange = (e) => {
        let { name = '' } = e.target;
        this.setState({ selectedTab: name });
    }

    TabsComponent = ({ name, label }) => {
        let { selectedTab = '' } = this.state;
        let { handleOnViewChange } = this;
        return <button className={`tabButtons btn btn-sm ${selectedTab === name ? "btn-info" : "btn-outline-info"}`} name={name} onClick={handleOnViewChange}>{label}</button>;
    }

    render() {

        let { TabsComponent, state, props } = this;
        let { selectedTab } = state;
        let {  }  = props;

        if (!((this.state.userObj.access || []).includes("Whatsapp"))) {
            return <Redirect to={"/"} />
        }

        return (
            <div>
                <Header />
                <div className={`container-fluid procurementMainDiv`}>
                    <div className="tabComponent">
                        <TabsComponent name="addAudience" label="Add Audience" />
                        <TabsComponent name="audienceList" label="Audience List"/>
                        <TabsComponent name="sendMessage" label="Send Message" />
                        <TabsComponent name="messageList" label="Message List" />
                    </div>
                    {
                        selectedTab === "addAudience" ? <AddAudienceWhatsapp
                            addAudienceWhatsapp={this.props.addAudienceWhatsapp}
                            downloadAudFormat={this.props.downloadAudFormat}
                        /> : ""
                    }
                    {
                        selectedTab === "audienceList" ? <AudienceListWhatsapp
                            fetchAudienceList={this.props.fetchAudienceList}
                            audienceList={this.props.audienceList}
                            downloadAudFile={this.props.downloadAudFile}
                        />:""
                    }
                    {
                        selectedTab === "sendMessage" ? <SendMessageForm
                            fetchAudienceList={this.props.fetchAudienceList}
                            audienceList={this.props.audienceList}
                            sendMessageWhatsapp={this.props.sendMessageWhatsapp}
                            testSendMessage={this.props.testSendMessage}
                        /> : ""
                    }
                    {
                        selectedTab === "messageList" ? <BulkMessageList
                            fetchBulkMessageList = {this.props.fetchBulkMessageList}
                            bulkMessageList={this.props.bulkMessageList}
                            approveMessage = {this.props.approveMessage}
                            downloadAttachmentFile={this.props.downloadAttachmentFile}
                            cancelMessage={this.props.cancelMessage}
                            userObj={this.state.userObj}
                        />:""
                    }
                </div>
            </div>
        )
    }

}

function mapStateToProps({ whatsappDashboard }) {
    let { audienceList = [], bulkMessageList = [] } = whatsappDashboard;
    return {
        audienceList: audienceList,
        bulkMessageList: bulkMessageList
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ getSearchResult, addAudienceWhatsapp, fetchAudienceList, sendMessageWhatsapp, fetchBulkMessageList, approveMessage, testSendMessage, downloadAudFormat, downloadAudFile, downloadAttachmentFile, cancelMessage }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SendMessage);